import flexRemunerationMealIcon from '@/assets/img/icons/benefits/meals.png'
import flexRemunerationTransportIcon from '@/assets/img/icons/benefits/transport.png'
import flexRemunerationNurseryIcon from '@/assets/img/icons/benefits/nursery.png'

const flexRemunerationIcons = [
  {
    code: 'FLEXIBLE_REMUNERATION_MEAL',
    icon: flexRemunerationMealIcon
  },
  {
    code: 'FLEXIBLE_REMUNERATION_TRANSPORT',
    icon: flexRemunerationTransportIcon
  },
  {
    code: 'FLEXIBLE_REMUNERATION_NURSERY',
    icon: flexRemunerationNurseryIcon
  }
]

const daysOfMonth = Array.from(Array(31), (el, i) => i + 1)

const hoursADay = Array.from(Array(24), (el, i) => {
  if (i < 10) {
    return `0${i}`
  } else {
    return `${i}`
  }
})
const minutesAnHour = Array.from(Array(60), (el, i) => {
  if (i < 10) {
    return `0${i}`
  } else {
    return `${i}`
  }
})

const hoursADay15Minutes = []
for (let i = 0; i < 24; i++) {
  for (let j = 0; j < 4; j++) {
    if (i < 10) {
      hoursADay15Minutes.push(`0${i}:${j === 0 ? '00' : 15 * j}`)
    } else {
      hoursADay15Minutes.push(`${i}:${j === 0 ? '00' : 15 * j}`)
    }
  }
}
const days = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']

export const DEFAULT_CURRENCY = 'EUR'

const EMPTY_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUGFdjYAACAAAFAAGq1chRAAAAAElFTkSuQmCC'

const EXPORT_TRANSACTION_REPORT_EXTENSION = '.zip'

const MINIMUM_GROSS_SALARY_RET_FLEX = 14000

const INSURANCE_MAX_EXEMPT = 41.67

export const MIMETYPES = {
  EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV: 'text/csv'
}

export const VALID_RECEIPT_MIMETYPES = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf', 'application/x-pdf']

/*
default vue-input-facade tokens
S = alpha characters
# = numerical characters
X = alpha numerical characters
A = alpha characters, transformed to uppercase
a = alpha characters, transformed to lowercase
\ = escape any of the above characters

*/

const customersWithNursery = [
  // { id: 168 },
  //  { id: 85 }
]

const sampletimeRestrictions = [
  {
    id: 1,
    activated: true,
    timeFrom: '12:53:57+00:00',
    timeTo: '15:00:00+00:00'
  },
  {
    id: 2,
    activated: true,
    timeFrom: '09:25:00+00:00',
    timeTo: '15:30:00+00'
  },
  {
    id: 3,
    activated: true,
    timeFrom: '10:00:00+00:00',
    timeTo: '17:00:00+00:00'
  },
  {
    id: 4,
    activated: true,
    timeFrom: '08:30:00+00:00',
    timeTo: '15:35:00+00:00'
  },
  {
    id: 5,
    activated: true,
    timeFrom: '18:30:00+00:00',
    timeTo: '23:35:00+00:00'
  },
  {
    id: 6,
    activated: true,
    timeFrom: '19:30:00+00:00',
    timeTo: '23:35:00+00:00'
  },
  {
    id: 7,
    activated: true,
    timeFrom: '09:30:00+00:00',
    timeTo: '15:35:00+00:00'
  }
]

export const addMonths = (date, months) => {
  const d = date.getDate()
  date.setMonth(date.getMonth() + +months)
  if (date.getDate() !== d) {
    date.setDate(0)
  }
  return date
}
/*
Colores
- Comidas y bebidas : naranja fc8f2fff,
- Comunicaciones: violeta 790abbff,
- Equipacion y hardware : rojo f17180ff,
- Formacion o entretenimiento: azul 5385d9ff,
- Informatica : verde 5fcb7cff
- Marketing y publicidad: Verde oscuro 0a756cff,
- Oficina: Rojo intenso f73647ff
- Otros: Amarillo oscuro c69612ff
- Viajes y tansporte: azul intenso 0089f2ff,

*/

export const categoriesColors = [
  {
    id: 1,
    categoryName: 'Comidas y bebidas',
    color: '#fc8f2f'
  },
  {
    id: 2,
    categoryName: 'Comunicaciones',
    color: '#790abb'
  },
  {
    id: 3,
    categoryName: 'Equipación y Hardware',
    color: '#f17180'
  },
  {
    id: 4,
    categoryName: 'Formación o entretenimiento',
    color: '#5385d9'
  },
  {
    id: 5,
    categoryName: 'Informática',
    color: '#5fcb7c'
  },
  {
    id: 6,
    categoryName: 'Marketing y publicidad',
    color: '#0a756c'
  },
  {
    id: 7,
    categoryName: 'Oficina',
    color: '#f73647'
  },
  {
    id: 8,
    categoryName: 'Otros',
    color: '#c69612'
  },
  {
    id: 9,
    categoryName: 'Viajes y transporte',
    color: '#0089f2'
  }

]

export {
  daysOfMonth,
  EMPTY_IMAGE,
  customersWithNursery,
  EXPORT_TRANSACTION_REPORT_EXTENSION,
  hoursADay,
  minutesAnHour,
  hoursADay15Minutes,
  days,
  MINIMUM_GROSS_SALARY_RET_FLEX,
  INSURANCE_MAX_EXEMPT,
  sampletimeRestrictions,
  flexRemunerationIcons
}
